import React, { useEffect, useState } from 'react';
import { useI18n } from 'react-simple-i18n';
import folk from '../assets/img/4.png';
import blocks from '../assets/img/5.png';
import pins from '../assets/img/6.png';
import bulb from '../assets/img/7.png';
import qstn from '../assets/img/qstn.png';
import aaa from '../assets/img/7aaa.png';
import bad from '../assets/img/7bad.png';
import { Link } from 'react-router-dom';
import FlipComponent from '../components/FlipComponent/FlipComponent';
import appstate, { getLocaledString } from '../appstate';
import itm1 from '../assets/img/stock/stock-3.jpeg';
import itm2 from '../assets/img/stock/stock-1.jpg';
import itm3 from '../assets/img/stock/stock-2.jpg';
import sss from '../assets/img/sss.png';
import ModulesView from './modulesView';
import FullPageLoadingComponent from '../components/fullPageLoadingComponent';
import multiarrows from '../assets/img/multiarrows.png';

function MeasureSections(props: { type: number; activeSection: string }) {
	const { activeSection } = props;

	const getSectionContent = () => {
		if (appstate.currentLanguage() === 'slSI') {
			if (activeSection === 'Delovni čas in organizacija dela') {
				return (
					'<p><strong>Zaposlen oziroma zaposlena lahko:</strong></p>\n' +
					'<ul>\n' +
					'    <li>na individualni ravni ali na ravni oddelka prosi za pravico do odklopa;</li>\n' +
					'    <li>na individualni ravni ali na ravni oddelka prosi za možnost opravljanja dela na domu;</li>\n' +
					'    <li>na individualni ravni ali na ravni oddelka prosi za uveljavo drsečega delovnega časa;</li>\n' +
					'    <li>na individualni ravni ali na ravni oddelka prosi za uveljavo fleksibilnega delovnega časa;</li>\n' +
					'    <li>na individualni ravni ali na ravni oddelka prosi za uveljavo fleksibilnega izmenskega časa.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Informiranje in komuniciranje') {
				return (
					'<p><strong>Zaposlen oziroma zaposlena lahko:</strong></p>\n' +
					'<ul>\n' +
					'    <li>predlaga vključitev področij enakosti spolov in usklajevanja poklicnega ter zasebnega življenja v letni razgovor, ki ga vodstvo izvaja z zaposlenimi;</li>\n' +
					'    <li>prosi vodstveni kader za strukturirano obrazložitev vseh ukrepov na nivoju organizacije, ki so zaposlenim na voljo za usklajevanje poklicnega in zasebnega življenja in spodbujajo enakost spolov v organizaciji, npr. v obliki letnega/&scaron;estmesečnega informacijskega izvlečka;</li>\n' +
					'    <li>predlaga vzpostavitev &raquo;&scaron;katle predlogov&laquo;, bodisi na ravni oddelka bodisi na ravni celotne organizacije, ki omogoča podajanje povratnih informacij o (ne)zadovoljstvu z obstoječimi politikami in ukrepi za usklajevanje poklicnega in zasebnega življenja;</li>\n' +
					'    <li>predlaga uvedbo ankete, ki meri zadovoljstvo vseh zaposlenih na delovnem mestu, kar vključuje tudi njihovo sposobnost usklajevanja poklicnega in zasebnega življenja;</li>\n' +
					'    <li>predlaga uvedbo semi-formalnih srečanj vseh zaposlenih posameznih oddelkov, na katerih se identificirajo nadaljne potrebe oddelka za usklajevanje poklicnega in zasebnega življenja;</li>\n' +
					'    <li>predlaga, da se vzpostavi samo en komunikacijski kanal, na katerem se izmenjuje informacije, npr. Basecamp, Asana.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Veščine vodstva') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>uvede sistem izobraževanja vodij na področju usklajevanja poklicnega in zasebnega življenja;</li>\n' +
					'    <li>krepi filozofijo/načela vodenja s poudarkom na usklajevanju poklicnega in zasebnega življenja;</li>\n' +
					'    <li>vodstvenim kadrom, ki se zaradi skrbstvenih obveznosti odločijo za skraj&scaron;an delovni čas omogoči, da ohranijo svoj položaj;</li>\n' +
					'    <li>pri letnem ocenjevanju vodij uvede kriterij uklajevanja poklicnega in zasebnega življenja in enakosti med spoloma;</li>\n' +
					'    <li>v etični kodeks organizacije uvede načelo enakosti med spoloma in usklajevanja poklicnega in zasebnega življenja.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Zaposlovanje in razvoj kadrov') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>v svojo organizacijsko kulturo uvede t. i. nepristransko zaposlovanje;</li>\n' +
					'    <li>sledi načelu spolne uravnoteženosti pri zaposlovanju novih kadrov;</li>\n' +
					'    <li>razvije primerne strategije za ponovno vključevanje zaposlenih po dalj&scaron;i odsotnosti;</li>\n' +
					'    <li>uvede načrtovanje kariernega razvoja zaposlenih;</li>\n' +
					'    <li>svojim zaposlenim omogoči določeno stopnjo avtonomije pri izobraževanju;</li>\n' +
					'    <li>naj pri letnih razgovorih uvede vidik usklajevanja poklicnega in zasebnega življenja;</li>\n' +
					'    <li>stremi k vzpostavljanju t. i. me&scaron;anih ekip;</li>\n' +
					'    <li>uvede psiholo&scaron;ko svetovanje in pomoč za svoje zaposlene;</li>\n' +
					'    <li>uvede delavnice in izobraževanja na področju spolnih stereotipov;</li>\n' +
					'    <li>s ciljem spodbujanja aktivnega očetovstva omogoči razgovor s kadrovsko službo in psihologom.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Nagrajevanje in napredovanje') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>razvije kulturo obdarovanja star&scaron;ev novorojenčkov;</li>\n' +
					'    <li>organizira aktivnosti, ki jih lahko koristijo zaposleni in njihovi družinski člani;</li>\n' +
					'    <li>uvede prispevek za star&scaron;e &scaron;olajočih otrok v obliki &scaron;tipendije;</li>\n' +
					'    <li>naj uvede posojila in finančno pomoč za zaposlene;</li>\n' +
					'    <li>sprejme ustrezen akt, s katerim bi na makro ravni opredelil možnosti nagrajevanja in stimulacij;</li>\n' +
					'    <li>pri vidiku napredovanja upo&scaron;teva načelo enakosti med spoloma in različne oblike skrbstvenih obveznosti zaposlenih.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Zadovoljstvo na delovnem mestu') {
				return (
					'<p><strong>Zaposlen oziroma zaposlena lahko:</strong></p>\n' +
					'<ul>\n' +
					'    <li>predlaga mesečno razvojno kavo na nivoju oddelka ali celotnega podjetja;</li>\n' +
					'    <li>predlaga uvedbo &raquo;skritega božička&laquo; na ravni oddelka ali celotne organizacije;</li>\n' +
					'    <li>predlaga uvedbo tematskih dni, v katerih lahko sodelujejo vsi zaposleni, npr. dan sladoleda, dan pice;</li>\n' +
					'    <li>predlaga, da se morebitni sestanki izvajajo v raznolikih okoljih, npr. na sprehodu po podjetju/zunaj podjetja;</li>\n' +
					'    <li>predlaga, da se uvede določena stopnja avtonomije pri izboru izobraževanj;</li>\n' +
					'    <li>predlaga, da se v letno strategijo izobraževanj za zaposlene vključijo tudi izobraževanja na temo du&scaron;evnega zdravja;</li>\n' +
					'    <li>vodstvu organizacije predstavi Katalog izobraževalnih modulov, ki je bil oblikovan v okviru projekta PROMETEJ.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Skrbstveno delo') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>organizira oziroma sofinancira različne oblike dnevnega varstva za otroke zaposlenih;</li>\n' +
					'    <li>vzpostavi ustrezne mehanizme, da lahko zaposleni za kraj&scaron;i čas ob posebnih okoli&scaron;činah na delovno mesto pripeljejo otroke;</li>\n' +
					'    <li>zaposlenim, ki imajo skrbstvene obveznosti, omogoči določeno kvoto ur, ki jih lahko za te namene koristijo brez nadome&scaron;čanja;</li>\n' +
					'    <li>uskladi dopust zaposlenih s &scaron;olskimi počitnicami;</li>\n' +
					'    <li>uvede dneve za druženje otrok zaposlenih, pri čemer naj poseben poudarek nameni otrokom mo&scaron;kih zaposlenih;</li>\n' +
					'    <li>spodbuja aktivno očetovstvo med svojimi zaposlenimi.</li>\n' +
					'</ul>'
				);
			}
		} else if (appstate.currentLanguage() === 'enUK') {
			if (activeSection === 'Informiranje in komuniciranje') {
				return (
					'<p><strong>Employee can:</strong></p>\n' +
					'<ul>\n' +
					'    <li>suggests the inclusion of the areas of gender equality and work-life balance in the annual interview conducted by management with employees;</li>\n' +
					'    <li>asks the management staff for a structured explanation of all measures at the level of the organization, which are available to employees to coordinate professional and private life and promote gender equality in the organization, e.g. in the form of an annual/six-monthly information extract;</li>\n' +
					'    <li>proposes the establishment of a "suggestion box", either at the level of the department or at the level of the entire organization, which allows feedback on (dis)satisfaction with existing policies and measures for balancing professional and private life;</li>\n' +
					'    <li>proposes the introduction of a survey that measures the satisfaction of all employees at work, which also includes their ability to achieve work-life balance;</li>\n' +
					'    <li>proposes the introduction of semi-formal meetings of all employees of individual departments, at which the further needs of the department for the coordination of professional and private life are identified;</li>\n' +
					'    <li>suggests establishing only one communication channel on which information is exchanged, e.g. Basecamp, Asana.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Zadovoljstvo na delovnem mestu') {
				return (
					'<p><strong>Employee can:</strong></p>\n' +
					'<ul>\n' +
					'    <li>proposes a monthly development coffee at the level of the department or the entire company;</li>\n' +
					'    <li>suggests the introduction of a "hidden Santa" at the level of the department or the entire organization;</li>\n' +
					'    <li>proposes the introduction of thematic days in which all employees can participate, e.g. ice cream day, pizza day;</li>\n' +
					'    <li>suggests that meetings can be held in diverse environments, e.g. on a walk around the company/outside the company;</li>\n' +
					'    <li>suggests that a certain degree of autonomy be introduced in the selection of yearly company workshops and trainings;</li>\n' +
					'    <li>suggests that the annual training strategy for employees also includes training on the topic of mental health;</li>\n' +
					'    <li>presents to the management of the organization the Catalog of educational modules, which was created within the framework of the PROMETHEUS project.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Delovni čas in organizacija dela') {
				return (
					'<p><strong>Employee can:</strong></p>\n' +
					'<ul>\n' +
					'    <li>requests the right to disconnect at the individual or departmental level;</li>\n' +
					'    <li>requests the possibility of doing work at home;</li>\n' +
					'    <li>requests the implementation of sliding working hours;</li>\n' +
					'    <li>requests the implementation of flexible working hours;</li>\n' +
					'    <li>requests the implementation of flexible shift time.</li>\n' +
					'</ul>'
				);
			}
		}

		return '';
	};

	const [slideOut, setSlideOut] = useState(false);
	const [showw, setShoww] = useState(false);

	// console.log(getMeasuresForSelectedSection());

	const colSpanFor = (index: number) => {
		const rr = index % 7;

		if (props.type === 2) {
			if (rr === 0) {
				return 6;
			}
			if (rr === 1) {
				return 6;
			}
			if (rr === 2) {
				return 12;
			}
		}

		if (rr === 0) {
			return 6;
		}
		if (rr === 1) {
			return 6;
		}
		if (rr === 2) {
			return 7;
		}
		if (rr === 3) {
			return 5;
		}
		if (rr === 4) {
			return 6;
		}
		if (rr === 5) {
			return 6;
		}
		if (rr === 6) {
			return 12;
		}
		if (rr === 7) {
			return 12;
		}
		return 12;
	};

	const colSpanForOther = (index: number) => {
		const rr = index % 8;

		return 12;
	};

	useEffect(() => {
		setTimeout(() => {
			return setShoww(true);
		}, Math.random() * 400 + 200);
	}, []);

	return (
		<>
			{!showw && <FullPageLoadingComponent />}
			<div
				className={`grid grid-cols-12 gap-12 relative h-fit transition-all z-1000 ${
					showw ? 'opacity-100' : 'opacity-0'
				}`}
				style={{
					maxHeight: showw ? '100vh' : '0px',
				}}
			>
				<div
					className={`col-span-12 duration-300 bg-white p-8 pb-12 ${
						activeSection === undefined
							? '-translate-x-full opacity-0'
							: 'translate-x-0 opacity-100'
					}`}
					style={{
						width:
							activeSection === 'Delovni čas in organizacija dela'
								? '100%'
								: '200%',
						marginLeft: [
							'Informiranje in komuniciranje',
							'Delovni čas in organizacija dela',
							'Veščine vodstva',
							'Skrbstveno delo',
						].includes(activeSection)
							? '0%'
							: '-100%',
						zIndex: 1000,
						position: 'relative',
					}}
				>
					<div
						className={`transform transition ${
							slideOut
								? '-translate-x-24 opacity-0'
								: 'translate-x-0 opacity-100'
						}`}
					>
						<img
							src={multiarrows}
							alt={''}
							className={'h-12 mx-auto mb-4'}
						/>
						<div
							className={
								'text-center flex justify-center flex-col gap-0 msrs text-base'
							}
							dangerouslySetInnerHTML={{
								__html: getSectionContent(),
							}}
						/>
					</div>
				</div>
			</div>
		</>
	);
}

export default function EmployeesAndEmployers() {
	const { t } = useI18n();

	// onmount
	React.useEffect(() => {
		// go to #id if present in url
		const hash = window.location.hash;
		if (hash) {
			const id = hash.replace('#', '');
			const element = document.getElementById(id);
			if (element) {
				window.scrollTo({
					top: element.offsetTop + 45,
				});
			}
		}
	}, []);

	const [activeSection, setActiveSection] = useState<string>('');

	return (
		<>
			<div
				className={
					'bg-white w-full text-center text-2xl py-4 mb-8 md:mb-24'
				}
			>
				{getLocaledString(
					'Kako lahko bolj učinkovito uskladim svoje poklicno in zasebno življenje?',
					'How can I achieve work-life balance?',
				)}
			</div>
			<div
				style={{ height: 'calc(100vh - 410px)' }}
				className={
					'relative hidden md:flex justify-center items-center flex-col pb-28'
				}
			>
				{/* People */}
				<div className={'max-w-8xl px-6 md:px-12 mx-auto relative'}>
					<img src={folk} alt={''} />
					<div className={'absolute top-0 left-0 ml-64 -mt-10'}>
						<div className={'bubble left text-lg'}>
							{getLocaledString(
								'Zakaj je usklajevanje poklicnega in zasebnega življenja sploh pomembno?',
								'Why is an effective coordination of professional and private life important?',
							)}
						</div>
					</div>
					<div className={'absolute -bottom-8 right-64'}>
						<div className={'bubble right text-lg'}>
							{getLocaledString(
								'Ker pripomore k zmanjšani količini stresa, optimizaciji časa, večji produktivnosti in boljšemu počutju!',
								'Because it contributes to a reduced amount of stress, optimization of time, greater productivity and better well-being!',
							)}
						</div>
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 md:mt-16 text-lg text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				{getLocaledString('Abeceda', 'Dictionary')}
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 mb-8 md:mb-0'
				}
			>
				<div className={'flex flex-col md:flex-row gap-12'}>
					<div
						className={
							'mb-1 flex justify-start items-center flex-col gap-0 text-center flex-1'
						}
					>
						<img
							src={qstn}
							alt={''}
							className={'md:w-16 w-10 text-lg mb-4'}
						/>
						<div className={'md:px-16 text-lg'}>
							{getLocaledString(
								'Kaj sploh je usklajevanje poklicnega in zasebnega življenja? S katerimi drugimi koncepti in pojmi se povezuje?',
								'What exactly is work-life balance? What other concepts is it associated with?',
							)}
						</div>
						<div className={'bg-white font-bold p-4 mt-4'}>
							{getLocaledString(
								'Abeceda služi kot podlaga za celovito razumevanje tematike. Prelistaj jo in spoznaj razsežnosti, ki jih koncept usklajevanja zasebnega in poklicnega življenja zajema.',
								'The dictionary serves as a basis for a comprehensive understanding of the concept of work-life balance. Flip through it and get to know the dimensions that the concept covers.',
							)}
						</div>
						<div className={'p-8 -mt-2'}>
							{getLocaledString(
								'Za boljše razumevanje vpliva spolnih stereotipov in z njimi povezanih spolnih vlog na (ne)zmožnost usklajevanja poklicnega in zasebnega življenja ti priporočamo tole platformo',
								'For a better understanding of the impact of gender stereotypes and related gender roles on the (in)ability to balance professional and private life, we recommend this platform',
							)}{' '}
							<Link
								to={
									'https://end-gender-stereotypes.campaign.europa.eu/work-life-balance_sl'
								}
								className={'underline text-lg'}
							>
								({getLocaledString('KLIK', 'CLICK')})
							</Link>
							.
						</div>
					</div>
					<div className={'flex-1'}>
						<FlipComponent />
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 md:mt-16 text-lg text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'izhodisce'}>
					{getLocaledString(
						'MOJA IZHODIŠČNA TOČKA?',
						'STARTING POINT?',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8'
				}
			>
				<div className={'flex flex-col m5-14'}>
					<div
						className={
							'mb-1 flex justify-start items-center flex-col gap-0 text-center md:px-52 relative mx-auto w-fit'
						}
					>
						{getLocaledString(
							'Pri naslavljanju kakršnihkoli izzivov je najpomembneje poznati lastno izhodiščno točko. Samo na ta način vemo kje točno se nahajamo in koliko korakov nas loči do končnega cilja.',
							'When addressing any challenges, the most important thing is to know your own starting point. Only this way we can know exactly where we are and how many steps separate us from our final destination.',
						)}
						<img
							src={pins}
							alt=""
							className={
								'absolute -top-4 right-28 w-24 opacity-20 md:opacity-100'
							}
						/>
					</div>
					<div
						className={
							'font-bold mt-10 text-center mx-auto relative w-fit'
						}
					>
						<img
							src={bulb}
							alt=""
							className={'absolute -top-4 -right-12 w-10'}
						/>
						{getLocaledString(
							'Uokviri svojo izhodiščno točko',
							'Frame your starting point',
						)}
					</div>
					<div className={'flex flex-col md:flex-row gap-4 mt-14'}>
						<div
							className={
								'flex-1 w-full h-96 bg-blue-faded flex justify-center items-center flex-col text-center'
							}
						>
							<Link
								to={'/quiz2'}
								className={
									'z-50 text-white text-shadow text-3xl relative w-full h-full group cursor-pointer md:py-16 text-lg md:py-0'
								}
							>
								<img
									src={aaa}
									alt=""
									className={
										'absolute top-0 left-0 object-cover w-full h-full -z-10'
									}
								/>
								<div
									className={
										'bg-blue-faded w-full h-full z-10 absolute top-0 left-0'
									}
								/>
								<div
									className={
										'h-full w-full flex justify-center items-center flex-col'
									}
								>
									<div
										className={
											'transition font-bold z-20 transform scale-100 group-hover:scale-110'
										}
									>
										{getLocaledString('KVIZ', 'QUIZ')}
									</div>
									<div
										className={
											'transition text-2xl z-20 px-14 transform scale-100 group-hover:scale-110'
										}
									>
										{getLocaledString(
											'Stres na delovnem mestu',
											'Stress in the workplace',
										)}
									</div>
								</div>
							</Link>
						</div>
						<div
							className={
								'flex-1 w-full h-96 bg-blue-faded flex justify-center items-center flex-col text-center'
							}
						>
							<Link
								to={'/quiz1'}
								className={
									'z-50 text-white text-shadow text-3xl relative w-full h-full group cursor-pointer py-5 md:py-0'
								}
							>
								<img
									src={bad}
									alt=""
									className={
										'absolute top-0 left-0 object-cover w-full h-full -z-10'
									}
								/>
								<div
									className={
										'bg-blue-faded w-full h-full z-10 absolute top-0 left-0'
									}
								/>
								<div
									className={
										'h-full w-full flex justify-center items-center flex-col'
									}
								>
									<div
										className={
											'transition font-bold z-20 transform scale-100 group-hover:scale-110'
										}
									>
										{getLocaledString('KVIZ', 'QUIZ')}
									</div>
									<div
										className={
											'transition text-2xl z-20 px-14 transform scale-100 group-hover:scale-110'
										}
									>
										{getLocaledString(
											'(Ne)uspešnost naslavljanja poklicnega in zasebnega življenja v organizaciji',
											'(Un)successful Addressal of Work-life Balance in My Organization',
										)}
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className={'flex flex-col md:flex-row gap-4 mt-4'}>
						<div
							className={
								'flex-1 text-center px-12 text-gray-700 italic text-sm'
							}
						>
							{getLocaledString(
								'Ali izkušam stres? Se soočam s preveliko količino obveznosti v zasebnem in poslovnem okolju? Kako lahko ublažim stres in pripomorem k svojemu optimalnemu delovanju?',
								'Am I experiencing stress? Am I dealing with an overwhelming amount of responsibilities in my private and professional environment? How can I alleviate stress and contribute to my optimal functioning?',
							)}
						</div>
						<div
							className={
								'flex-1 text-center px-12 text-gray-700 italic text-sm'
							}
						>
							{getLocaledString(
								'Ali podjetje v katerem delam naslavlja in promovira usklajevanje poklicnega in zasebnega življenja? Kakšna orodja in politike so na voljo zaposlenim za dobro uravnoteženost poklicnih in zasebnih obveznosti?',
								'Does the company I work for address and promote the balance between professional and private life? What tools and policies are available to employees for a good balance of professional and private obligations?',
							)}
						</div>
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 md:mt-16 text-lg text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'dosegsprememb'}>
					{getLocaledString(
						'UKREPI ZA DOSEGANJE SPREMEMB',
						'MEASURES',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div className={'mb-8'}>
					{getLocaledString(
						'Izredno pomembno je, da si z drugimi zaposlenimi in vodstvom naše organizacije delimo vsaj nekatere aspekte vizije, kaj pomeni uspešno usklajevanje poklicnega in zasebnega življenja. Preglej ukrepe v treh vsebinskih sklopih in z malce poguma ter volje spodbudi sodelavce in sodelavke k dosegljivim spremembam.',
						'It is extremely important that we share at least some aspects of the vision of what successful work-life balance means with other employees and the management of our organization. Review the measures in the three thematic clusters and with a bit of courage and will, encourage your colleagues to make achievable changes.',
					)}
				</div>

				<div className={'flex justify-center items-center flex-col'}>
					<div className={'flex flex-col h-full w-full'}>
						<div className={'h-full flex flex-col md:flex-row'}>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Informiranje in komuniciranje'
													? ''
													: 'Informiranje in komuniciranje',
											);
										}}
									>
										{getLocaledString(
											'Informiranje in komuniciranje',
											'Communication',
										)}
									</div>
									<img
										src={itm1}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Informiranje in komuniciranje' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Zadovoljstvo na delovnem mestu'
													? ''
													: 'Zadovoljstvo na delovnem mestu',
											);
										}}
									>
										{getLocaledString(
											'Zadovoljstvo na delovnem mestu',
											'Job satisfaction',
										)}
									</div>
									<img
										src={itm2}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Zadovoljstvo na delovnem mestu' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
						</div>
						<div className={'h-full flex flex-col md:flex-row'}>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Delovni čas in organizacija dela'
													? ''
													: 'Delovni čas in organizacija dela',
											);
										}}
									>
										{getLocaledString(
											'Delovni čas in organizacija dela',
											'Work hours organization',
										)}
									</div>
									<img
										src={itm3}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Delovni čas in organizacija dela' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 md:mt-16 text-lg text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'dosegsprememb'}>
					{getLocaledString(
						'VČASIH POTREBUJEMO MALCE NAVDIHA...',
						'SOMETIMES WE NEED A LITTLE INSPIRATION...',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div className={'mt-4'}>
					{appstate.currentLanguage() === 'sl' ? (
						<>
							<b>Podcast</b> je odlično orodje za učenje,
							premišljevanje in doseganje miselnih napredkov.
							Naslednji strokovnjaki s svojim delom navdihujejo
							ljudi za doseganje želenih sprememb v poklicnem in
							zasebnem življenju.
						</>
					) : (
						<>
							A <b>podcast</b> is a great tool for learning,
							reflecting and achieving minor or major mental
							breakthroughs. The following experts use their work
							to inspire people to achieve the desired changes in
							their professional and private lives.
						</>
					)}
				</div>
				<div className={'flex flex-col md:flex-row gap-12 py-8'}>
					<div
						className={
							'flex-1 text-justify relative flex justify-center items-center py-16'
						}
					>
						<img
							src={sss}
							alt=""
							className={
								'absolute top-0 left-0 h-full w-full object-cover z-10'
							}
						/>
						<div
							className={
								'bg-blue-faded w-full h-full absolute top-0 left-0 z-20'
							}
						/>
						<div
							className={
								'flex flex-col gap-6 mt-3 z-50 relative text-3xl text-center text-white text-shadow '
							}
						>
							<a
								href={
									'https://adamgrant.net/podcasts/work-life/'
								}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								Adam Grant: WorkLife
							</a>
							<a
								href={'https://annadkornick.com/'}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								{/* eslint-disable-next-line react/no-unescaped-entities */}
								Anna Dearmon Kornick: It's About Time
							</a>
							<a
								href={'https://www.nancyray.com/workandplay'}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								Nancy Ray: Work and Play
							</a>
							<a
								href={'https://www.beyondthetodolist.com/'}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								Erik Fisher: Beyond the To-Do List
							</a>
							<a
								href={
									'https://www.kayleehackney.com/elegantbalance'
								}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								Kaylee Hackney: Elegant Balance
							</a>
						</div>
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 md:mt-16 text-lg text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'izobmodul'}>
					{getLocaledString(
						'IZOBRAŽEVALNI MODULI',
						'EDUCATIONAL MODULES',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div className={'bg-white p-4 font-bold text-xl'}>
					{getLocaledString(
						'Izobrazba je najpomembnejše orodje in ključ do uspeha!',
						'Education is the most important tool and key to success!',
					)}
				</div>
				<div className={'my-7 md:px-16 text-sm md:text-lg'}>
					{getLocaledString(
						'Izobraževalni moduli se lahko uporabljajo individualno, s sodelavci ali pa se predstavijo vodstvu organizacije s predlogom, da se jih vključi v naslednja strokovna izobraževanja. Vsak posameznik in posameznica lahko identificirata vsaj en relevanten modul, glede na svoje osebne okoliščine in z njimi povezane potrebe.',
						'The educational modules can be used individually, with colleagues or presented to the management of the organization with a proposal to include them in the next professional trainings. Each individual can identify at least one relevant module, based on their personal circumstances and related needs.',
					)}
				</div>
				<div className={'my-7 md:px-16 text-sm md:text-lg'}>
					{getLocaledString(
						'Za celovit pregled pedagoških pristopov in poglobljeno razumevanje izobraževalnih modulov predlagamo prenos Kataloga izobraževalnih modulov',
						'For a comprehensive overview of pedagogical approaches and a deeper understanding of educational modules, we suggest downloading the Catalog of Educational Modules',
					)}{' '}
					<a
						className={'underline inline-flex'}
						href={
							appstate.currentLanguage() === 'slSI'
								? `https://projekt-prometej.si/EducationalModulesCatalog.pdf`
								: `https://projekt-prometej.si/EducationalModulesCatalogEnglish.pdf`
						}
						target={'_blank'}
						rel="noreferrer"
					>
						({getLocaledString('KLIK', 'CLICK')})
					</a>
					.
				</div>
				<ModulesView />
			</div>
		</>
	);
}
